module.exports = __webpack_public_path__ + "img/2.6ee7349b.svg";